<template>
    <div class="cps-main-page">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item>奖池信息</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>

      <div class="page-content">
        <el-row @keyup.enter.native="loadData(1)">
          <el-input v-model.trim="queryField.poolId" size="small" placeholder="奖池id"></el-input>
          <el-input v-model.trim="queryField.gameId" size="small" placeholder="游戏id"></el-input>
            <el-input v-model.trim="queryField.userId" size="small" placeholder="用户id"></el-input>
          <el-select v-model="queryField.poolStatus" size="small" placeholder="奖池状态">
            <el-option label="待开奖" value="1"/>
            <el-option label="开奖中" value="2"/>
            <el-option label="已开奖" value="3"/>
          </el-select>
          <el-select v-model="queryField.prizeStatus" size="small" placeholder="奖品发放状态">
            <el-option label="待发放" value="1"/>
            <el-option label="已审核" value="2"/>
            <el-option label="发放成功" value="3"/>
            <el-option label="发放失败" value="4"/>
            <el-option label="作废" value="5"/>
          </el-select>
          <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-row>

        <el-table class="cps-table-data"
                  :data="tableData"
                  size="small"
                  border
                  v-loading="loading"
                  :height="height"
                  style="width: 100%"
                  id="rebateSetTable">
          <el-table-column
              prop="pool_id"
              width="80"
              label="奖池id">
          </el-table-column>
          <el-table-column
              prop="role_game_id"
              width="80"
              label="游戏id">
          </el-table-column>
          <el-table-column
              prop="pool_name"
              width="120"
              label="奖池名">
          </el-table-column>
          <el-table-column
              prop="pool_balance"
              width="120"
              label="奖池金额">
            <template slot-scope="scope">
              <span>{{ scope.row.pool_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="pool_status"
              width="120"
              :formatter="PoolStatusFormat"
              label="奖池状态">
          </el-table-column>
          <el-table-column
              prop="join_role"
              width="180"
              label="中奖角色">
          </el-table-column>
          <el-table-column
              prop="user_id"
              width="120"
              label="用户id">
          </el-table-column>
          <el-table-column
              width="120"
              label="是否绑定微信">
            <template slot-scope="scope">
              {{ scope.row.info_type === '1' ? '已绑定' : '未绑定' }}
            </template>
          </el-table-column>
          <el-table-column
              prop="lotteryTime"
              width="160"
              label="开奖时间">
          </el-table-column>
          <el-table-column
              prop="status"
              width="100"
              :formatter="PrizeStatusFormat"
              label="奖品发放状态">
          </el-table-column>
          <el-table-column
              label="操作">
            <template slot-scope="scope">
              <!-- <el-button type="text"  size="small" @click="queryTop(scope.row.pool_id)">查看排名</el-button> -->
              <el-button type="text" v-if="scope.row.pool_status === 3 && scope.row.status === '1'" size="small" @click="audit(scope.row.pool_id)">通过审核</el-button>
              <!-- <el-button type="text" size="small" @click="addRoleVisible = true;form.pool_id=scope.row.pool_id">添加角色</el-button>
              <el-button type="text" size="small" @click="Reissue(scope.row.pool_id)" v-if="scope.row.pool_status === 3 && scope.row.status === '4'">重新发放</el-button>
              <el-button type="text" size="small" v-if="scope.row.status === '3'" @click="RedPacketStatus(scope.row.pool_id)">查看红包状态</el-button> -->
              <el-button type="text" v-if="scope.row.pool_status === 3 && scope.row.status === '1' || scope.row.status === '4'" size="small" @click="cancellation(scope.row.pool_id)">废弃</el-button>
              <el-button type="text" v-if="scope.row.pool_status === 1" size="small" @click="deleteCashPool(scope.row.pool_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--底部分页-->
        <el-pagination
            class="cps-table-data"
            @current-change="loadData"
            background
            :page-size="pageSize"
            :current-page="currentIndex"
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>
      </div>

      <el-drawer
              :visible.sync="showTop"
              direction="rtl"
              size="750px">
        <el-table :data="topData" class="drawer-table-data" border >
          <el-table-column property="pr_id" label="ID" width="100"></el-table-column>
          <el-table-column property="user_id" label="用户id" width="120"></el-table-column>
          <el-table-column property="join_role" label="角色名称" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.win === 1" style="color: #e55825;font-weight: bold">{{scope.row.join_role}}</span>
                <span v-else>{{scope.row.join_role}}</span>
              </template>
          </el-table-column>
          <el-table-column property="num" label="数量" width="100"></el-table-column>
          <el-table-column
                  label="操作"  width="200">
            <template slot-scope="scope">
              <el-button type="text"  size="small" @click="setWinner(scope.row.pr_id)">预设</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>

      <el-dialog title="添加角色" 
                 width="30%" 
                 :visible.sync="addRoleVisible"
                 :close-on-press-escape="false"
                 :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="addRoleForm">
          <el-form-item label="用户id" :label-width="formLabelWidth" prop="user_id">
            <el-input v-model.number="form.user_id" autocomplete="off" placeholder="请输入用户id"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" :label-width="formLabelWidth" prop="join_role">
            <el-input v-model.trim="form.join_role" autocomplete="off" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="区服名称" :label-width="formLabelWidth" prop="server_name">
            <el-input v-model.trim="form.server_name" autocomplete="off" placeholder="请输入区服名称"></el-input>
          </el-form-item>
          <el-form-item label="数量" :label-width="formLabelWidth" prop="num">
            <el-input v-model.number="form.num" autocomplete="off" placeholder="请输入参加数量"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addRoleVisible = false">取 消</el-button>
          <el-button type="primary" @click="addRole('addRoleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {
  queryCashPoolList,
  throughAudit,
  queryCashPoolTop,
  setCashPoolWin,
  addCashPoolRole,
  doReissue,
  nullify, 
  queryRedPacketStatus,
  deleteCashPool
} from '@/api/request';

export default {
  name: "cashPool",
  data(){
    return{
      pageSize: 15,
      currentIndex: 1,
      total: 0,
      loading: false,
      height: window.innerHeight - 230,
      queryField:{
        poolId: '',
        gameId: '',
        poolStatus: '',
        userId: '',
        prizeStatus: ''
      },
      tableData:[],
      topData: [],
      showTop: false,
      selectPoolId: 0,
      addRoleVisible: false,
      formLabelWidth: '120px',
      form:{
        pool_id: '',
        user_id: '',
        join_role: '',
        server_name: '',
        num: ''
      },
      rules: {
        user_id: [
          { required: true, message: '请输入用户id', trigger: 'blur' },
          { type: 'number', message: '用户id必须为数字'}
        ],
        join_role:[
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
        server_name:[
          { required: true, message: '请输入区服名称', trigger: 'blur' },
        ],
        num:[
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', message: '数量必须为数字'}
        ]
      },
    }
  },
  mounted() {
    this.loadData(1);
  },
  methods:{
    loadData(index){
      this.loading = true;
      let params = {
        pageNo: index,
        pageSize: this.pageSize,
        params: this.queryField
      }
      queryCashPoolList(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
        this.loading = false;
      })
    },
    audit(poolId){
      throughAudit(poolId).then( res => {
        if(res.data.success){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.loadData(this.currentIndex);
        }else {
          this.$message({
            message: res.data.error.message,
            type: 'error'
          });
        }
      })
    },
    queryTop(id) {
      this.selectPoolId = id;
      queryCashPoolTop(id).then(res => {
        if(res.data.success){
          this.showTop = true;
          this.topData = res.data.data;
        }
        else {
          this.$message({
            message: res.data.error.message,
            type: 'error'
          });
        }
      });
    },
    setWinner(id) {
        setCashPoolWin(this.selectPoolId, id).then(res => {
            if(res.data.success){
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              this.showTop = false;
              this.loadData(1);
            }
            else {
                this.$message({
                    message: res.data.error.message,
                    type: 'error'
                });
            }
        })
    },
    addRole(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addCashPoolRole(this.form).then(res => {
            if(res.data.success){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.addRoleVisible = false;
              this.$refs[formName].resetFields();
              this.loadData(1);
            }else {
              this.$message({
                message: res.data.error.message,
                type: 'error'
              });
            }
          })
        } else {
          return false;
        }
      });
    },
    Reissue(poolId){
      this.$confirm('确认要重新发放该奖池吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doReissue(poolId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    cancellation(poolId){
      this.$confirm('确认要废弃该奖池码？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        nullify(poolId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    deleteCashPool(poolId){
      this.$confirm('确定要删除该奖池吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCashPool(poolId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    RedPacketStatus(poolId){
      queryRedPacketStatus(poolId).then(res => {
        if(res.data.success){
          let status = this.RedPacketStatusFormat(res.data.data);
          this.$alert("奖池id：" + poolId + "，红包状态：" + status,"红包状态",{
            confirmButtonText: '确定',
          });
        }else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    reset(){
      this.queryField = {
        poolId: '',
        gameId: '',
        poolStatus: ''
      }
      this.loadData(1);
    },
    PoolStatusFormat(row, column, cellValue){  //1:待开奖,2:开奖中,3:已开奖
      let str = '';
      if (cellValue == 1){
        str = '待开奖';
      }else if(cellValue == 2){
        str = '开奖中';
      }else if(cellValue == 3){
        str = '已开奖';
      }
      return str;
    },
    PrizeStatusFormat(row, column, cellValue){  //1：待发放,2：已审核,3：发放成功,4 发放失败,5:作废
      let str = '';
      if (cellValue == 1){
        str = '待发放';
      }else if(cellValue == 2){
        str = '已审核';
      }else if(cellValue == 3){
        str = '发放成功';
      }else if (cellValue == 4){
        str = '发放失败';
      }else if(cellValue == 5){
        str = '作废';
      }
      return str;
    },
    RedPacketStatusFormat(cellValue){
      let rep = "";
      if(cellValue === "SENDING"){
        rep = "发放中";
      }else if(cellValue === "SENT"){
        rep = "已发放待领取";
      }else if(cellValue === "FAILED"){
        rep = "发放失败";
      }else if(cellValue === "RECEIVED"){
        rep = "已领取";
      }else if(cellValue === "RFUND_ING"){
        rep = "退款中";
      }else if(cellValue === "REFUND"){
        rep = "已退款";
      }
      return rep;
    }
  }
}
</script>

<style scoped lang="scss">
  /deep/.drawer-table-data {
    padding: 0 10px;
      thead {
        color: #2b2929;
        tr{
          th{
            background-color: #f5f5f5;
          }
        }
      }

    td {
      font-weight: 500;
      .cell{
        button{
          padding: 0;
        }
      }
    }
    .el-table__cell{
      padding: 8px 0;
    }

  }
</style>